// Après « Je l'ai reçue », la mise en place attend que l'accusé du service
// worker soit arrivé au serveur (#25) : seul lui prouve que Sensa Rappel pourra
// vérifier la réception des rappels sur ce téléphone.
import { api } from './api';

const pause = (ms: number) => new Promise((ok) => setTimeout(ok, ms));

/** Vrai dès qu'un des envois de test est accusé ; faux après `essais` lectures. */
export async function attendreAccuse(
  envoiIds: readonly string[],
  { essais = 6, pauseMs = 1000, verifier = api.verifierTest } = {},
): Promise<boolean> {
  if (envoiIds.length === 0) return true;
  for (let i = 0; i < essais; i++) {
    if (i > 0) await pause(pauseMs);
    const lus = await Promise.all(
      envoiIds.map((id) =>
        verifier(id).then(
          (r) => r.recu,
          () => false,
        ),
      ),
    );
    if (lus.some(Boolean)) return true;
  }
  return false;
}
